<template>
  <div>
    <div class="grey lighten-5 col-sm-12 input-container cbg-white-container">
      <v-row>
        <v-col cols="12" md="3" sm="6" class="search-referal-box">
          <label for>Search by name / Referral code</label>
          <div class="position-relative search-div">
            <input
              class="form-control"
              label="Search by Name"
              placeholder="Name"
              @input="debounceSearch()"
              v-model="search"
            />
            <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
              <crossSVG />
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="3" class="d-none-mob"></v-col>
        <v-col cols="12" md="3" class="d-none-mob"></v-col>
        <v-col cols="12" md="3">
          <div class="mt-3 ml-4 text-end mob-m-l-0 mob-t-left referaluserbtn">
            <v-btn
              v-if="
                permissions.includes('CAN_CREATE_REFERRAL_MARKETING_AGENCIES')
              "
              @click="addMarketingAgent()"
              class="btn btn-primary mr-4 mt-4"
            >Add New User</v-btn>
          </div>
        </v-col>
      </v-row>

      <loader v-if="showLoader"></loader>
      <v-col cols="12" class="mt-4 pl-0 pr-0">
        <div class="table-div overflow-auto">
          <table class="table userlistTable small-table-width small-table-padding">
            <thead>
              <tr class="table-success">
                <th scope="col">Ref code no</th>
                <th scope="col">Company name</th>
                <th scope="col">Contact person</th>
                <th scope="col">Contact Number</th>
                <th scope="col">Contact Email</th>
                <th
                  v-if="
                    permissions.includes(
                      'CAN_DEACTIVE_REFERRAL_MARKETING_AGENCIES'
                    )
                  "
                  scope="col"
                >Active/Deactive</th>
                <th
                  v-if="
                    permissions.includes('CAN_EDIT_REFERRAL_MARKETING_AGENCIES')
                  "
                  scope="col"
                >Action</th>
              </tr>
            </thead>

            <tbody v-if="!isEmpty">
              <tr v-for="(list, i) in referralUserList" :key="i">
                <td>
                  <div>{{ list.referral_code }}</div>
                </td>
                <td>
                  <div>{{ list.company_name ? list.company_name : "&#8213;" }}</div>
                </td>
                <td>
                  <div>{{ list.contact_person }}</div>
                </td>
                <td>
                  <div>{{ list.contact_number }}</div>
                </td>
                <td>
                  <div>{{ list.contact_email ? list.contact_email : "&#8213;" }}</div>
                </td>
                <td
                  v-if="
                    permissions.includes(
                      'CAN_DEACTIVE_REFERRAL_MARKETING_AGENCIES'
                    )
                  "
                >
                  <div>
                    <v-switch
                      hide-details
                      class="mt-0"
                      v-model="list.is_active"
                      @change="toggleActivationMarketingAgent(list)"
                      color="success"
                    ></v-switch>
                  </div>
                </td>
                <td
                  v-if="
                    permissions.includes('CAN_EDIT_REFERRAL_MARKETING_AGENCIES')
                  "
                >
                  <div>
                    <v-btn @click="editMarketingAgent(list)" class="btn btn-success mr-3">Edit</v-btn>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="isEmpty">
              <tr>
                <td colspan="8">
                  <h2 class="text-center">No Data Found</h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
      <pagination
        class="mx-0 pagination-block"
        :recordPerPage="recordPerPage"
        :total="total"
        @changePage="changePage"
        v-if="!isEmpty"
      />
    </div>
    <new-referral-marketing-agency
      v-if="openCreateForm"
      @close="closeModal"
      @getApiCall="getReferralMarketingAgenciesList"
      :openCreateForm="openCreateForm"
      :modalType="modalType"
      :MarketingAgentData="MarketingAgentData"
    ></new-referral-marketing-agency>
  </div>
</template>
<script>
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";
import formats from "@/formats";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
const loader = () => import("@/components/loader.vue");
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const NewReferralMarketingAgency = () =>
  import("@/components/modals/NewReferralMarketingAgency.vue");
const pagination = () => import("@/views/common/Pagination");
export default {
  components: {
    loader,
    Datepicker,
    NewReferralMarketingAgency,
    pagination,
    ...pickSvg("crossSVG")
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      formats,
      dayJS,
      openCreateForm: false,
      showLoader: false,
      currentPage: 1,
      recordPerPage: 10,
      totalPage: 0,
      referralUserList: [],
      isEmpty: false,
      search: "",
      modalType: "edit",
      MarketingAgentData: {},
      total: 0
    };
  },
  mounted() {
    this.getReferralMarketingAgenciesList();
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    //  page change event call
    changePage(page) {
      this.currentPage = page.currentPage;
      this.getReferralMarketingAgenciesList();
    },

    // search filter event call
    debounceSearch: debounce(function() {
      this.getReferralMarketingAgenciesList();
    }, 500),

    // close modal
    closeModal() {
      this.openCreateForm = false;
    },

    // toggleActivationMarketingAgent method
    toggleActivationMarketingAgent(userData) {
      let obj = {
        is_active: userData.is_active
      };
      let url = `${config.BASE_URL}api/v2/admin/referral-marketing-agent/${userData._id}/activation-toggle`;
      this.$http.put(url, obj).then(res => {
        if (res.data.status) {
          if (userData.is_active) {
            this.$swal({
              text: "User Activated Successfully",
              icon: "success",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "Ok"
            });
          } else {
            this.$swal({
              text: "User De-activated Successfully",
              icon: "success",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "Ok"
            });
          }
          this.getReferralMarketingAgenciesList();
        }
      });
    },

    // getReferralMarketingAgenciesList Data
    getReferralMarketingAgenciesList() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        search_text: this.search
      };
      let url = `${config.BASE_URL}api/v2/admin/referral-marketing-agents`;
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.referralUserList = response.body.data.list;
            this.totalPage = response.body.data.total;
            this.total = response.body.data.count;
          } else {
            this.referralUserList = [];
            this.isEmpty = true;
          }
        }
      });
    },

    // add modal open event
    addMarketingAgent() {
      this.currentPage = 1;
      this.openCreateForm = true;
      this.modalType = "Add";
    },

    // edit modal open event
    editMarketingAgent(userData) {
      this.currentPage = 1;
      this.openCreateForm = true;
      this.MarketingAgentData = userData;
      this.modalType = "Edit";
    }
  }
};
</script>
<style lang="scss">
.table th,
.table td {
  vertical-align: middle;
}
</style>